<template>
  <div class="content">
    <h1 class="has-text-centered">Transformator</h1>
    <div class="box">
      <h2>Was ist ein Transformator?</h2>
      <p>
        Ein Transformator ist ein statisches Bauteil, dass die elektrische Energie von einer Schaltung zur anderen durch elektromagnetische Induktion überträgt. Transformatoren werden meistens
        verwendet um die Spannungspegel zwischen den Stromkreisen zu erhöhen ("step up") oder zu verringern ("step down").
      </p>

      <h2>Funktionsprinzip</h2>
      <p>
        Das Funktionsprinzip eines Transformators ist einfach. Durch die gegenseitige Induktion zwischen zwei oder mehreren Wicklungen (auch als Spulen bezeichnet) kann elektrische Energie zwischen
        den Stromkreisen übertragen werden.
      </p>

      <h3>Theorie</h3>
      <p>
        Angenommen, du hast eine Wicklung (Spule), die von einer Wechselstromquelle versorgt wird. Der Wechselstrom erzeugt in der Wicklung einen sich ständig ändernden und wechselnden Fluss. Wenn
        eine andere Wicklung in die Nähe gebracht wird, wird ein Teil dieses Wechselstroms auf die zweite Spule übertragen. Da sich sich der Strom in seiner Amplitude und Richtung ständig ändert wird
        auch in der zweiten Wicklung (Sekundärwicklung) ein Wechselstrom induziert. Und wenn der Stromkreis in der zweiten Wicklung geschlossen ist, beginnt auch dort ein (Wechsel-)Strom zu fließen.
      </p>
      <p>
        Die Wicklung, an der eine Wechselstromquelle angelegt ist, wird als "Primärwicklung" bezeichnet. Und die durch gegenseitige Induktion die gewünschte Ausgangsspannung liefert, wird
        "Sekundärwicklung" genannt.
      </p>
      <p>
        Ein Transformator, der die Spannung zwischen den Primär- und Sekundärwicklungen erhöht, wird als "step-up"-Transformator bezeichnet. Umgekehrt wird ein Transformator, der die Spannung zwischen
        den primären und sekundären Wicklungen verringert, als "step-down"-Transformator bezeichnet.
      </p>

      <h2>Bestandteile eines Transformators</h2>
      <p>Ein Transformator besteht grundsätzlich aus drei Teilen:</p>
      <ul>
        <li>Primäre Wicklung</li>
        <li>Magnetkern</li>
        <li>Sekundäre Wicklung</li>
      </ul>

      <h3>Primäre Wicklung</h3>
      <p>Erzeugt einen magnetischen Fluss, wenn sie an eine Wechselstromquelle angeschlossen wird.</p>

      <h3>Magnetkern</h3>
      <p>Der Magnetkern bildet zusammen mit der primären Wicklung eine Induktivität.</p>

      <h3>Sekundäre Wicklung</h3>
      <p>
        Der Fluss, der durch die Primärwicklung erzeugt wird, durchläuft den Kern und überträgt sich auf die Sekundärwicklung. Diese Wicklung wird ebenfalls auf den gleichen Kern gewickelt und liefert
        die gewünschte Ausgangsspannung des Transformators.
      </p>
      <h2>Weiterführende Links</h2>
      <p>
        <ul class="fa-ul pb-3">
          <li>
            <span class="fa-li"><i class="fas fa-arrow-circle-right"></i></span>
            <a href="https://de.wikipedia.org/wiki/Transformator" target="_blank">Wikipedia-Artikel</a>
          </li>
          <li>
            <span class="fa-li"><i class="fas fa-arrow-circle-right"></i></span>
            <router-link :to="{name: 'calculator-transformator-efficiency'}">Transformator Wirkungsgrad berechnen</router-link>
          </li>
        </ul>
      </p>
    </div>
    <FeedbackBox />
  </div>
</template>

<script>
import FeedbackBox from '@/components/FeedbackBox.vue'

export default {
  name: 'theory-transformator',
  components: {
    FeedbackBox
  },
  metaInfo: {
    title: 'Transformator | Elektrotechnik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Ein Transformator ist ein statisches Bauteil, dass die elektrische Energie von einer Schaltung zur anderen durch elektromagnetische Induktion überträgt.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'electrical-elements' })
  }
}
</script>
